import React from "react";
export default function ComputerTable({ computerData }) {
  const data =
    (computerData?.flatMap(record =>
      record.receipt_item_Info.map(item => ({
        ...item,
        date: record.date,
        grn_no: record.grn_no,
        bill_no: record.bill_no,
      }))
    ) || []).sort((a, b) => b.grn_no - a.grn_no);

  return (
    <div className="border rounded-lg shadow-md overflow-auto h-[500px]">
      <table className="min-w-full border-collapse bg-white">
        <thead className="bg-gray-100 sticky top-0 z-10">
          <tr>
            <th className="p-3 border-b border-gray-200 text-left font-semibold">Date</th>
            <th className="p-3 border-b border-gray-200 text-left font-semibold">GRN No.</th>
            <th className="p-3 border-b border-gray-200 text-left font-semibold">Bill No.</th>
            <th className="p-3 border-b border-gray-200 text-left font-semibold">Item</th>
            <th className="p-3 border-b border-gray-200 text-left font-semibold">Qty</th>
            <th className="p-3 border-b border-gray-200 text-left font-semibold">Status</th>
            <th className="p-3 border-b border-gray-200 text-left font-semibold">Serial No.</th>
            <th className="p-3 border-b border-gray-200 text-left font-semibold">Warranty</th>
            <th className="p-3 border-b border-gray-200 text-left font-semibold">Warranty Expiry</th>
            <th className="p-3 border-b border-gray-200 text-left font-semibold">User</th>
          </tr>
        </thead>
        <tbody className="bg-white">
          {data.map((row, index) => (
            <tr key={index} className="hover:bg-gray-50">
              <td className="p-3 border-b border-gray-100">
                {new Date(row.date).toLocaleDateString()}
              </td>
              <td className="p-3 border-b border-gray-100">{row.grn_no}</td>
              <td className="p-3 border-b border-gray-100">{row.bill_no}</td>
              <td className="p-3 border-b border-gray-100">{row.item_title}</td>
              <td className="p-3 border-b border-gray-100">{row.receipt_item_qty}</td>
              <td className="p-3 border-b border-gray-100">{row.status}</td>
              <td className="p-3 border-b border-gray-100">{row.serialNumber}</td>
              <td className="p-3 border-b border-gray-100">{row.warranty}</td>
              <td className="p-3 border-b border-gray-100">
                {new Date(row.warrantyExpiry).toLocaleDateString("en-GB")}
              </td>
              <td className="p-3 border-b border-gray-100">
                {Array.isArray(row.item_user) ? row.item_user.join(", ") : row.item_user}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
